import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { provideGesamtabfrageGlobals } from './gesamtabfrage.globals';
import { SOFTLINE_PERMISSION_GESAMTABFRAGE } from './gesamtabfrage.permissions';
import { GesamtabfrageConfig } from './gesamtabfrage.shared';

export function provideGesamtabfrage(
  config?: GesamtabfrageConfig
): Array<EnvironmentProviders | Provider> {
  return [provideGesamtabfrageModuleEntry(), ...provideGesamtabfrageGlobals(config)];
}

function provideGesamtabfrageModuleEntry(): Array<EnvironmentProviders | Provider> {
  return [
    provideSoftAppsModule(
      {
        name: '#GESAMTABFRAGE.TITLE',
        title: '#GESAMTABFRAGE.TITLE',
        icon: 'fa-regular fa-file-invoice',
        route: '/gesamtabfrage',
        permission: SOFTLINE_PERMISSION_GESAMTABFRAGE,
        group: getModuleGroupByName('Stammdaten'),
      },
      withSoftAppsModuleTranslation({ de }),
      withSoftAppsModuleInfo({
        library: '@softapps/wws/gesamtabfrage',
        description: 'Gesamtabfrage über Belege und Bewegungen.',
      })
    ),
  ];
}

export const gesamtabfrageProviders: Array<EnvironmentProviders | Provider> = [
  ...provideGesamtabfrageModuleEntry(),
  ...provideGesamtabfrageGlobals(),
];
